import {
    createNotification,
    INotificationProperties,
    Notification,
} from '@vfde-brix/ws10/notification';
import {
    IPatternWithNoPatternBusinessLogic,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import { selectError } from '../container/App/selectors';
import { startAppListening } from '../container/App/listener';
import { StoneDopErrorType } from '../container/App/interfaces/error';

/**
 * Mount notification
 */
export default function mountNotification (
    id: string,
    properties: INotificationProperties | IPatternWithNoPatternBusinessLogic = NO_PATTERN_BUSINESS_LOGIC,
): Notification | null {
    const container = document.getElementById(id);

    /* istanbul ignore if */
    if (!container) {
        return null;
    }

    const notification = createNotification(container, properties);

    startAppListening({
        predicate: (action, currentState, previousState) =>
            selectError(currentState) !== selectError(previousState),
        effect: (action, listenerApi) => {
            const hasError = selectError(listenerApi.getState());

            if (hasError) {
                const { headline, subline } = window.additionalPageOptions.errors[StoneDopErrorType.General];
                notification?.update({
                    stdHeadline: headline,
                    txtContent: subline,
                });
            }

            notification?.toggleContainer(!hasError);
        },
    });

    return notification;
}
